import AOS from "aos";

(function ($) {
  //on document ready scripts start
  $(function () {
    //toggleText Function
    $.fn.extend({
      toggleText: function (a, b) {
        return this.text(this.text() == b ? a : b);
      },
    });

    //view mobile menu
    function toggleSiteMenu() {
      $(".overlay-menu").toggleClass("overlay-menu--visible");
      $(".site-curtain--menu").fadeToggle(200);
      $("html").toggleClass("is-locked");
    }
    $(".site-menu-toggle, .site-curtain--menu").on("click", function () {
      toggleSiteMenu();
    });

    //sticky js
    const stickySiteHeaderTop = $(".site-header").sticky({
      zIndex: 1000,
    });
    // const stickySiteHeaderBottom = $(".site-menu-bottom__menu").sticky({
    //   zIndex: 1000,
    // });
    $(window).on("resize", function () {
      stickySiteHeaderTop.sticky("update");
      // stickySiteHeaderBottom.sticky("update");
    });

    //Mobile sub menu toggle
    $(".sub-menu-toggle").on("click", function () {
      $(this).toggleText("expand_more", "expand_less").next().slideToggle(300);
    });

    // Add Slick Counter
    $(".content-block--hero").each(function (index, section) {
      var $section = $(section);
      var $slider = $section.find(".site-carousel");
      var zero;

      var updateSliderCounter = function (slick) {
        var $counter = $section.find(".slider-counter__current");
        var currentSlide = slick.slickCurrentSlide() + 1;
        zero = slick.slideCount < 10 ? "0" : "";

        $counter.text(zero + currentSlide);
      };

      $slider.on("init afterChange", function (event, slick) {
        updateSliderCounter(slick);
      });
    });

    // Slick Slider
    $(".site-carousel").slick({
      prevArrow:
        '<button type="button" class="slick-prev"><span class="slick-arrow__icon material-icons">west</span></button>',
      nextArrow:
        '<button type="button" class="slick-next"><span class="slick-arrow__icon material-icons">east</span></button>',
      dots: true,
    });

    //Accordion
    $(".accordion__button").on("click", function () {
      $(this).removeClass("on");
      $(this).next().slideUp("normal");
      if ($(this).next().is(":hidden") == true) {
        $(this).addClass("on");
        $(this).next().slideDown("normal");
      }
    });
    $(".accordion__content").hide();

    //IE Message
    if (window.document.documentMode) {
      var currentDiv = document.getElementById("site-body");
      currentDiv.insertAdjacentHTML(
        "afterbegin",
        '<div class="ie-message">⚠️You are using an outdated Internet Explorer browser. For a faster, safer browsing experience, upgrade for FREE today! <a href="https://www.microsoft.com/en-us/edge" target="_blank" class="btn">Upgrade</a></div>'
      );
    }

    /*
  Woocommerce Scripts START
  */

    $(".woocommerce-store-notice__dismiss-link").on("click", function () {
      siteHeader();
    });

    //View Mini Cart
    function toggleMiniCart() {
      $(".custom-mini-cart").toggleClass("custom-mini-cart--visible");
      $(".site-curtain--cart").fadeToggle(200);
    }
    $(
      ".site-menu__cart .custom-mini-cart--show, .custom-mini-cart--hide, .site-curtain--cart"
    ).on("click", function (event) {
      event.preventDefault();
      toggleMiniCart();
    });

    //Cart Animation after product add
    $(document.body).on("added_to_cart", function () {
      $(".custom-mini-cart--show")
        .addClass("shadow-pulse")
        .on("animationend", function () {
          $(this).removeClass("shadow-pulse");
        });
    });

    //Account Menu Toggle
    $(".account-menu-toggle").on("click", function (event) {
      event.preventDefault();
      $(".account-menu").fadeToggle(300);
    });
    $("html").on("click", function () {
      $(".account-menu").fadeOut(300);
    });
    $(".site-menu__account").on("click", function (event) {
      event.stopPropagation();
    });

    /*
    Woocommerce Scripts END
    */

    //Search
    $(".search-toggle, .site-search__close, .site-search__overlay").on(
      "click",
      function () {
        $(".site-search").fadeToggle(300);
        $(".site-search .search__input").focus();
      }
    );

    //Animation on scroll
    AOS.init({
      once: true,
      duration: 1000,
      offset: 70,
    });
  }); //on document ready scripts END
})(jQuery, this);
